module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-indicator-perfect.1c18279979a6d4145c30b4f8276c4740.svg";